
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/skills",
      function () {
        return require("private-next-pages/skills.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/skills"])
      });
    }
  